export class AdminRuntimeTimerStats {
  timerKey: string

  timerName: string

  description: string

  period: string

  dueTime: string

  lastStartedAtUtc: string | null

  lastCompletedAtUtc: string | null

  lastDurationMs: number | null

  isStalled: boolean

  healthStatus: string

  healthMessage: string | null

  lastError: string | null

  constructor(data: Partial<AdminRuntimeTimerStats> = {}) {
    this.timerKey = data.timerKey ?? ""

    this.timerName = data.timerName ?? ""

    this.description = data.description ?? ""

    this.period = data.period ?? ""

    this.dueTime = data.dueTime ?? ""

    this.lastStartedAtUtc = data.lastStartedAtUtc ?? null

    this.lastCompletedAtUtc = data.lastCompletedAtUtc ?? null

    this.lastDurationMs = data.lastDurationMs ?? null

    this.isStalled = data.isStalled ?? false

    this.healthStatus = data.healthStatus ?? "Saudável"

    this.healthMessage = data.healthMessage ?? null

    this.lastError = data.lastError ?? null
  }
}
